import axios from "axios";

const deleteAdtInfoTitle = (uuid) => {
  return new Promise((resolve, reject) => {
    axios
      .post(`/serialnumber/api/v1/additional-info-title/delete/${uuid}`, {})
      .then((response) => resolve(response.data))
      .catch((error) => {
        return reject(error.response.data);
      });
  });
};

export default deleteAdtInfoTitle;
